import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "DexTools",
    "Etherscan",
    "JavaScript",
    "Solscan",
    "Birdeye",
    "DexScreener",
    "Flask",
    "Python"
];

const labelsSecond = [
    "Docker",
    "Linux",
    "Postgres",
    "AWS",
    "Azure",
    "Linux",
    "Flask",
    "Python"
];

const labelsThird = [
    "OpenAI",
    "Groq",
    "LangChain",
    "Qdrant",
    "Hugging Face",
    "LlamaIndex",
    "Streamlit",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Services</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Smart Contract & Web Analysis</h3>
                    <p>We don’t just call random tokens — every call is backed by on-chain data and dev-level analysis.
Our team reviews token contracts, holder distributions, and liquidity setups before posting any play.
</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tools & Stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Bot Automations & Tracking</h3>
                    <p>We use advanced Telegram & Python bots to monitor and auto-track new tokens, detect stealth launches, and alert early entries before they blow up.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tools & Stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>AI-Powered Alpha & Trend Detection</h3>
                    <p>We integrate GenAI and LLMs to process hundreds of new launches, social mentions, and on-chain signals daily — filtering out the noise to find the next 100x meme before the crowd.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tools & Stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;